<template>
  <v-row class="py-3" >
    <v-col class="d-flex align-center" cols="12" md="6">
      <v-card-subtitle class="title px-0">{{
        $t("mainStore.aboutStore.gender.title")
      }}</v-card-subtitle>
    </v-col>
    <v-col class="d-flex align-center mb-6" cols="12" md="6">
        <template v-if="readOnly">
            <div class="d-flex justify-space-between" style="flex: 1 1 100%">
        <div class="d-flex flex-column" style="flex: 0 0 40%">
          <div class="d-flex">
            <v-icon>mdi-human-female</v-icon>
            <v-text-field
            
            :readonly="readOnly"
            ref="textArea"
             :value="storeGender.female"
              suffix="%"
            ></v-text-field>
          </div>
          <span class="ml-6">{{
            $t("mainStore.aboutStore.gender.woman")
          }}</span>
        </div>
        <div class="d-flex flex-column" style="flex: 0 0 40%">
          <div class="d-flex">
            <v-icon>mdi-human-male</v-icon>
            <v-text-field
            :readonly="readOnly"
              :value="storeGender.male"
              suffix="%"
              label=""
            ></v-text-field>
          </div>
          <span class="ml-6">{{ $t("mainStore.aboutStore.gender.man") }}</span>
        </div>
      </div>

         <v-btn class="mb-6" icon @click="enableEditMode()" >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        </template>
        <template v-else>
            <div class="d-flex justify-space-between" style="flex: 1 1 100%">
        <div class="d-flex flex-column" style="flex: 0 0 40%">
          <div class="d-flex">
            <v-icon>mdi-human-female</v-icon>

            <v-text-field
            ref="textArea"
              type="number"
              width="100%"
              min="0"
              max="100"
              step="1"
              :rules="[
                percentRules.loanMin(storeGenderInput.female, 0),
                percentRules.loanMaxMax(storeGenderInput.female, 100),
              ]"
              v-model="storeGenderInput.female"
              suffix="%"
              @input="changePercent('female')"
            ></v-text-field>
          </div>
          <span class="ml-6">{{
            $t("mainStore.aboutStore.gender.woman")
          }}</span>
        </div>

        <div class="d-flex flex-column" style="flex: 0 0 40%">
          <div class="d-flex">
            <v-icon>mdi-human-male</v-icon>
            <v-text-field
              min="0"
              max="100"
              step="1"
              width="100%"
              :rules="[
                percentRules.loanMin(storeGender.male, 0),
                percentRules.loanMaxMax(storeGender.male, 100),
              ]"
              type="number"
              v-model="storeGenderInput.male"
              suffix="%"
              label=""
              @keyup.enter="saveChanges" 
              @keyup.esc="cancelChanges"
              @input="changePercent('male')"
            ></v-text-field>
          </div>
          <span class="ml-6">{{ $t("mainStore.aboutStore.gender.man") }}</span>
        </div>
        <div class="d-flex mb-10 ml-6">

<v-btn icon color="success" @click="saveChanges">
      <v-icon>mdi-check-circle-outline</v-icon>
    </v-btn>
    <v-btn icon color="info" @click="cancelChanges">
      <v-icon>mdi-restart</v-icon>
    </v-btn>
</div>
      </div>

        </template>
  

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GenderSecVue",

  props: {
    storeGender: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
        readOnly: true,
      storeGenderInput: this.storeGender,

      percentRules: {
        loanMin(value, min) {
          return (
            (value || "") >= min ||
            `
      Valor de porcentaje mínimo${min}`
          );
        },
        loanMaxMax(value, max) {
          return (value || "") <= max || `Valor porcentual máximo${max} `;
        },
      },
    };
  },

  methods: {
    changePercent(type, value) {
      if (type == "male") {
        this.storeGenderInput.female =
          100 - parseFloat(this.storeGenderInput.male);
        if (parseFloat(value < 0)) {
          console.log("menor == 0");
          this.storeGenderInput.female = 100;
        }
      }
      if (type == "female") {
        this.storeGenderInput.male =
          100 - parseFloat(this.storeGenderInput.female);
        if (parseFloat(value < 0)) {
          this.storeGenderInput.male = 100;
        }
      }
    },

    enableEditMode() {
      this.readOnly = false;
      this.$nextTick(() => {
        this.$refs.textArea.focus()
      });
    },
    saveChanges() {
      this.readOnly = true;
      this.$emit("update:storeGender", this.storeGenderInput);
    },
    cancelChanges() {
      this.storeGenderInput = this.storeGender;
      this.readOnly = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
